import { formatMoney } from '@betterment/js-runtime';
import { Box, Heading, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';
import { ThemedImage } from '@betterment/shared-components/src/components/themed-image/ThemedImage';

import { RetirementContributionRecommendation } from '../../../../graphql/schema';
import { addUrlParams } from '../../../../Shared/path-helpers';

const ICON_SIZE = '36px';

export const ContributionRecommendationRow: React.FC<{
  contributionRecommendation: RetirementContributionRecommendation;
  returnToUrl: string;
}> = ({ contributionRecommendation, returnToUrl }) => {
  const { icon, title, eligibilityAmount, body, cta } = contributionRecommendation;

  return (
    <Box
      css={{
        display: 'grid',
        gridTemplateColumns: `${ICON_SIZE} 1fr`,
        gap: 'space.200',
        alignItems: 'start',
      }}
    >
      <Box
        css={{
          gridRow: '1 / -1',
          width: ICON_SIZE,
          height: ICON_SIZE,
          alignSelf: 'center',
        }}
      >
        <ThemedImage themedAsset={icon} alt="account icon" />
      </Box>
      <Box
        css={{
          gridColumn: 2,
          gridRow: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: 'space.25',
          alignSelf: 'center',
        }}
      >
        <Heading variant="title100">{title}</Heading>
        {eligibilityAmount && (
          <Text variant="text50" css={{ color: 'text.weak' }}>
            Eligibility: {formatMoney(eligibilityAmount)}
          </Text>
        )}
      </Box>
      <Text
        css={{
          gridColumn: 2,
          gridRow: 2,
          '& a': {
            color: 'text',
            textDecoration: 'underline',
          },
        }}
        variant="text100"
        dangerouslySetInnerHTML={{ __html: body }}
      />
      {cta && (
        <Box css={{ gridColumn: 2, gridRow: 3 }}>
          <SambaAutoLink
            to={addUrlParams(cta.url, { return_to: returnToUrl })}
            variant="solidSecondary"
            spacing="compact"
          >
            {cta.text}
          </SambaAutoLink>
        </Box>
      )}
    </Box>
  );
};
